import { useMemo } from "react";

import type {
  RiskManagementMetricType,
  SystemOverviewMetricType,
} from "$/__generated__/graphql";

import type {
  SummariesFormattersGrouped,
  SummariesFormattersGroups,
} from "./types";
import { groupFooterFormatters } from "./utils";

export const useSummariesFormatters = (
  selectionMetric: SystemOverviewMetricType | RiskManagementMetricType,
  systemMetric: SystemOverviewMetricType | RiskManagementMetricType,
  formatterMap: SummariesFormattersGrouped,
): SummariesFormattersGroups => {
  return useMemo(
    () => groupFooterFormatters(selectionMetric, systemMetric, formatterMap),
    [systemMetric, selectionMetric, formatterMap],
  );
};
